<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Mini Projects</v-flex>
                    <v-flex v-else>Update Mini Projects</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text v-if="!Update_Details">
                    <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-select v-if="!AddMiniProjectCategory" item-value='_id' item-text='name' return-object v-model="SelectedMiniProjectCategory" :items="MiniProjectCategory" label="Select Category">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Category_Name }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Category_Name }}    
                                </template>
                            </v-select>
                            <v-flex v-else style="width: 85%;">
                                <v-text-field label="Mini Project Category" v-model="Category"></v-text-field>
                            </v-flex>
                            <v-btn icon v-if="!AddMiniProjectCategory" @click="OpenUpdate"> <v-icon>add</v-icon> </v-btn>
                            <v-flex v-else style="padding: 13px;">
                                <v-btn icon style="margin:0px;" @click="AddMiniProjectCategoryToDB"> <v-icon>library_add</v-icon> </v-btn>
                                <v-btn icon style="margin:0px;" @click="CloseUpdate"> <v-icon>cancel</v-icon> </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-flex>
                            <v-text-field label="Mini Project Title" v-model="Project_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Actual Price" v-model="Actual_Price"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Discounted Price" v-model="Discounted_Price"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 14px;font-weight: 400;padding-bottom: 10px">Mini Project Description :</v-flex>
                            <vue-editor v-model="Project_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>
                    <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedMiniProjectCategory" :items="MiniProjectCategory" label="Select Category">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Category_Name }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Category_Name }}    
                                </template>
                            </v-select>
                        </v-layout>
                        <v-flex>
                            <v-text-field label="Mini Project Title" v-model="Project_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Actual Price" v-model="Actual_Price"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Discounted Price" v-model="Discounted_Price"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 15px;font-weight: bold;padding-bottom: 10px">Mini Project Description :</v-flex>
                            <vue-editor v-model="Project_Description"></vue-editor>
                        </v-flex>
                        <v-flex>
                            <v-switch v-model="Enable" :label="`Enable/Disable : ${Enable.toString()}`"></v-switch>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details" @click="SubmitMiniProject">Add Mini Project </v-btn>
                        <v-btn color="success" v-else @click="UpdateMiniProjectListing">Update Mini Project </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Update_Details              : false,
            AddMiniProjectCategory      : false,
            MiniProjectCategory         : [],
            SelectedMiniProjectCategory : {},
            Project_Title               : "",
            Project_Description         : "",
            Enable                      : false,
            Category                    : "",
            CurrentListing              : {},
            Project_Id                  : "",
            Actual_Price                : 0,
            Discounted_Price            : 0
        }
    },  
    methods:{
        CloseDialog(){
            
            this.ClearForm()
            this.$emit('close')
        },
        OpenUpdate(){
            this.AddMiniProjectCategory = true
        },
        CloseUpdate(){
            this.AddMiniProjectCategory = false
        },
        GetDetailstoUpdate(Project){

            this.GetMiniProjectCategoryList()
                .then(response =>{
                    
                    this.SelectedMiniProjectCategory = this.MiniProjectCategory.find(x => x['_id'] == Project['Category_Id'])
                    this.Project_Id          = Project['_id']
                    this.Project_Title       = Project['Project_Title']
                    this.Project_Description = Project['Project_Description']
                    this.Actual_Price = Project['Actual_Price']
                    this.Discounted_Price = Project['Discounted_Price']
                    this.Enable              = Project['Enable']
                    this.Update_Details = true
                })
                .catch(error =>{

                    console.log(error)
                })
        },
        AddMiniProjectCategoryToDB(){
            
            let Category = {}
            Category['Category_Name'] = this.Category

            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/addminiprojectcategory`,Category)
                        .then(response =>{
                            
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Mini Project Category","Color":"green","Close": false });
                            this.Category   = ''
                            this.MiniProjectCategory.push(response["data"]["response"])
                            this.CloseUpdate()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Mini Project Category","Color":"red","Close": false });
                        })
        },
        SubmitMiniProject(){

            let Mini_Project = {}
            Mini_Project["Category_Id"]          = this.SelectedMiniProjectCategory["_id"]
            Mini_Project["Project_Title"]        = this.Project_Title
            Mini_Project['Project_Description']  = this.Project_Description
            Mini_Project['Actual_Price']         = parseInt(this.Actual_Price)
            Mini_Project['Discounted_Price']     = parseInt(this.Discounted_Price)
            Mini_Project['Enable']               = true
    
            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/addminiproject`,Mini_Project)
                        .then(response =>{
                            
                            this.$store.commit('SetIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Mini Project","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Mini Project","Color":"red","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedMiniProjectCategory = {}
            this.Project_Title          = ""
            this.Project_Description    = ""
            this.Category               = ''
            this.Actual_Price           = 0
            this.Discounted_Price       = 0
            this.CloseUpdate()
            
        },
        GetMiniProjectCategoryList(){

            return new Promise((resolve,reject) =>{

                this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/getprojectcategories`,{})
                            .then(response =>{
    
                                this.MiniProjectCategory = response["data"]["response"]
                                resolve(true)
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                            })
            })

        },
        UpdateMiniProjectListing(){

            let MiniProject = {}
            MiniProject['Project_Id']                     = this.Project_Id
            MiniProject['update']                         = {} 
            MiniProject['update']["Category_Id"]          = this.SelectedMiniProjectCategory["_id"]
            MiniProject['update']["Project_Title"]        = this.Project_Title
            MiniProject['update']['Project_Description']  = this.Project_Description
            MiniProject['update']['Actual_Price']        = parseInt(this.Actual_Price)
            MiniProject['update']['Discounted_Price']    = parseInt(this.Discounted_Price)
            MiniProject['update']['Enable']               = this.Enable
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/updateminiproject`,MiniProject)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Mini Project","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Mini Project","Color":"red","Close": false });
                        })
        }
    }
}
</script>
<style scoped>

</style>